import React from 'react';
import { SkeletonLoading } from '@saleshandy/design-system';
import Table from '../../../../shared/design-system/components/organisms/table';
import { PaginationShowHide } from '../../../../shared/design-system/components/organisms/table/types';

const SequenceListTableFallback: React.FC = () => {
  const columns = [
    {
      dataField: 'checkbox',
      text: '',
      headerLoadingSkeleton: <SkeletonLoading width={16} height={16} />,
      cellLoadingSkeleton: <SkeletonLoading width={16} height={16} />,
      headerClasses: 'selection-cell-header',
      cellClasses: 'selection-cell',
    },
    {
      dataField: 'progressActive',
      text: '',
      cellLoadingSkeleton: <SkeletonLoading width={24} height={14} />,
      headerClasses: 'sequence-switch-header-col',
      cellClasses: 'sequence-switch-col',
    },
    {
      dataField: 'title',
      text: 'Sequence Name',
      headerLoadingSkeleton: <SkeletonLoading width={120} height={14} />,
      cellLoadingSkeleton: <SkeletonLoading width={180} height={14} />,
      headerClasses: 'client-sequence-name-header skeleton-loading',
      cellClasses: 'sequence-name skeleton-loading',
    },
    {
      dataField: 'sequenceProgressPer',
      text: 'Sequence Progress',
      headerLoadingSkeleton: <SkeletonLoading width={120} height={14} />,
      cellLoadingSkeleton: <SkeletonLoading width={180} height={14} />,
      headerClasses: 'client-sequence-progress-header',
      cellClasses: 'sequence-progress-cell',
    },
    {
      dataField: 'sequenceScore',
      text: 'Score',
      headerLoadingSkeleton: <SkeletonLoading width={62} height={14} />,
      cellLoadingSkeleton: (
        <SkeletonLoading width={32} height={24} borderRadius={20} />
      ),
      headerClasses: 'sequence-score-header',
      cellClasses: 'sequence-score-cell',
    },
    {
      dataField: 'total',
      text: 'Prospect',
      headerLoadingSkeleton: <SkeletonLoading width={62} height={14} />,
      cellLoadingSkeleton: <SkeletonLoading width={28} height={14} />,
      headerClasses: 'client-prospect-col-header',
      cellClasses: 'prospect-col-cell',
    },
    {
      dataField: 'contacted',
      text: 'Contacted',
      headerLoadingSkeleton: <SkeletonLoading width={62} height={14} />,
      cellLoadingSkeleton: <SkeletonLoading width={28} height={14} />,
      headerClasses: 'client-contacted-col-header',
      cellClasses: 'contacted-col-cell',
    },
    {
      dataField: 'opened',
      text: 'Opened',
      headerLoadingSkeleton: <SkeletonLoading width={70} height={14} />,
      cellLoadingSkeleton: <SkeletonLoading width={28} height={14} />,
      headerClasses: 'opened-col-header',
      cellClasses: 'opened-col-cell',
    },
    {
      dataField: 'replied',
      text: 'Replied',
      headerLoadingSkeleton: <SkeletonLoading width={70} height={14} />,
      cellLoadingSkeleton: <SkeletonLoading width={28} height={14} />,
      headerClasses: 'replied-col-header',
      cellClasses: 'replied-positive-col-cell',
    },
    {
      dataField: 'positiveSentiment',
      text: 'Positive',
      headerLoadingSkeleton: <SkeletonLoading width={70} height={14} />,
      cellLoadingSkeleton: <SkeletonLoading width={28} height={14} />,
      headerClasses: 'positive-col-header',
      cellClasses: 'replied-positive-col-cell',
    },
    {
      dataField: 'sequenceEmailAccountCount',
      text: 'Email Accounts',
      headerLoadingSkeleton: <SkeletonLoading width={74} height={14} />,
      cellLoadingSkeleton: <SkeletonLoading width={28} height={14} />,
      headerClasses: 'email-accounts-col-header',
      cellClasses: 'email-accounts-col-cell',
    },
    {
      dataField: 'userName',
      text: 'Created By',
      headerLoadingSkeleton: <SkeletonLoading width={90} height={14} />,
      cellLoadingSkeleton: (
        <div className="d-flex align-items-center">
          <SkeletonLoading width={24} height={24} circle />
          <div style={{ marginLeft: '10px' }}>
            <SkeletonLoading width={80} height={14} />
          </div>
        </div>
      ),
      headerClasses: 'created-by-header',
      cellClasses: 'sequence-owner',
    },
    {
      dataField: 'actions',
      text: '',
      headerLoadingSkeleton: <SkeletonLoading width={24} height={14} />,
      cellLoadingSkeleton: <SkeletonLoading width={24} height={14} />,
      headerClasses: 'client-sequence-action-header',
      cellClasses: 'sequence-action',
    },
  ];
  return (
    <div className="sequence-list">
      <Table
        data={[]}
        columns={columns}
        isLoading={true}
        pagination={PaginationShowHide.HIDE}
        paginationOptions={{
          options: {
            page: 1,
            limit: 10,
            totalElements: 10,
          },
        }}
        headerWrapperClasses="sequence-table-header"
        bodyWrapperClasses="sequence-body-wrapper"
      />
    </div>
  );
};

export default SequenceListTableFallback;
